import _ from 'lodash'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import styled from 'styled-components'

import { themeColor } from '../../components/theme'

import { Box } from '../../components/Box'
import { ErrorText } from '../../components/Text/ErrorText'
import { Icon } from '../../components/Icons'
import { Flex } from '../../components/Flex'
import { TaxesFootnote } from '../../containers/TaxesFootnote'
import { useViewportSize } from '../../hooks/useViewportSize'
import { DomainType } from '../../redux/domains'
import { getDomains } from '../../redux/domains/selectors'
import { getOrderItems, OrderItemStatusCode } from '../../redux/order'
import { RootState } from '../../redux/types'
import { createTFunction } from '../../utils/helpers'
import { CartItemComponent, CartItemMobileComponent } from '../../containers/Cart/CartItem'
import BorderedWrapper from '../../components/BorderedWrapper'

import { CartItemsProps } from './CartItemsProps'
import { CartPrice } from './CartPrice'

const requiredDomains = [DomainType.Culture, DomainType.DeliveryOption]

const AlertWrapper = styled(Flex)`
  background-color: ${themeColor('white')};
  z-index: 5;
  position: relative;
`

const Alert = styled.div`
  display: flex;
  align-items: center;
`

const AlertIcon = styled(Icon)`
  font-size: 20px;
  margin-right: 8px;
`

export const CartList = ({ productsUmbracoData, accountingUnavailable }: CartItemsProps) => {
  const viewportSize = useViewportSize()
  const { t, i18n } = useTranslation(['cart', 'investigation'])
  const tc = createTFunction('cart:', t)

  const items = useSelector(getOrderItems)

  const domainsData = useSelector((state: RootState) =>
    getDomains(state, {
      domains: requiredDomains,
      language: i18n.language
    })
  )

  const allWithError = _.every(items, i => i.statusCode === OrderItemStatusCode.Error)

  return (
    <>
      <AlertWrapper mt="40px" flexDirection="column" paddingTop={'24px'}>
        {accountingUnavailable && (
          <Alert>
            <AlertIcon color="warning" type="ExclamationCircleOutlined" />
            {t('cart:ServiceUnavailable')}
          </Alert>
        )}
        <BorderedWrapper mt="40px" flexDirection="column" padding="24px" mx="-24px">
          {_.map(items, x => {
            const umbracoData = _.find(productsUmbracoData, y => y.bifCode === x.reportType)
            if (viewportSize?.isDesktop || viewportSize?.isWide) {
              return (
                <CartItemComponent
                  key={x.customerRequestId}
                  data={x}
                  domainsData={domainsData}
                  umbracoData={umbracoData}
                />
              )
            } else {
              return (
                <CartItemMobileComponent
                  key={x.customerRequestId}
                  data={x}
                  domainsData={domainsData}
                  umbracoData={umbracoData}
                />
              )
            }
          })}
          {allWithError && (
            <Box px={3} pb={1} pt={1}>
              <ErrorText>{tc('CartProcessingError')}</ErrorText>
            </Box>
          )}

          <CartPrice />
        </BorderedWrapper>
        <TaxesFootnote wrapperProps={{ block: true, textAlign: 'right' }} />
      </AlertWrapper>
    </>
  )
}
